<script setup>
    const props = defineProps({
        title: {
            type: String,
            required: true,
            default: '',
        },

        cards: {
            type: Array,
            required: true,
            default: [],
        },

        content: {
            type: String,
            required: false,
            default: 'site',
        },
    });

</script>

<template>
    <!-- hd-container sits on the SECTION, not on the header. It used to be on
         the header alone, which guttered the title and left the map and the
         card list running flush to the window edges beneath it. Both consumers
         (neighborhood detail, tour detail) style only the header's VERTICAL
         padding, so the horizontal gutter belongs one level up where it can
         cover the whole block. -->
    <section id="title-map" class="title-with-map-and-cards hd-container">
        <header id="title-map-header" class="container">
            <h1 v-html="title" class="headline-1"></h1>
        </header>
        <BlocksMap :locations="cards" :content="content" navId="title-map-header" />
    </section>
</template>

<style lang="scss" scoped>

    .title-with-map-and-cards {

        .container {
            .headline-1 {
                margin-bottom: 14px;
            }
        }
        
        .carousel-item {
            flex: 0 0 300px;
        }
    }
</style>
